import React from "react";

export default function Error404() {
  return (
    <div className="container">
      <div className="error404">
        Page Not Found! Something Went Wrong.
      </div>
    </div>
  );
}
